import UserAuthStore from "../store/userStore";

const isCollaborator = (space) => {
  const user_id = UserAuthStore.getState()?.user?.uid;
  return space?.collaborators?.some((c) => c.user_id === user_id && c.status === "ACCEPTED");
};

export const PERMISSIONS = {
  IS_OWNER: (space) => {
    if (!space?.owner_id) return true;
    const user_id = UserAuthStore.getState()?.user?.uid;
    return user_id === space?.owner_id;
  },
  EDIT_SPACE: (space) => {
    if (!space?.owner_id) return true;
    const user_id = UserAuthStore.getState()?.user?.uid;
    return user_id === space?.owner_id;
  },
  DELETE_SPACE: (space) => {
    if (!space?.owner_id) return true;
    const user_id = UserAuthStore.getState()?.user?.uid;
    return user_id === space?.owner_id;
  },
  CREATE_NEW_SPARK_IN_SPECTRA: (space) => {
    if (!space?.owner_id) return true;
    const user_id = UserAuthStore.getState()?.user?.uid;
    return user_id === space?.owner_id || isCollaborator(space);
  },
  EDIT_SPARK_IN_SPECTRA: (space) => {
    if (space?.agent_id) return true;
    if (!space?.owner_id) return true;
    const user_id = UserAuthStore.getState()?.user?.uid;
    return user_id === space?.owner_id;
  },
  DELETE_SPARK_IN_SPECTRA: (space) => {
    if (space?.agent_id) return true;
    if (!space?.owner_id) return true;
    const user_id = UserAuthStore.getState()?.user?.uid;
    return user_id === space?.owner_id;
  },
  MOVE_SPARK_IN_SPECTRA: (space) => {
    if (!space?.owner_id) return true;
    const user_id = UserAuthStore.getState()?.user?.uid;
    return user_id === space?.owner_id || isCollaborator(space);
  },
  CAN_INVITE_COLLABORATORS: (space) => {
    if (!space?.owner_id) return true;
    const user_id = UserAuthStore.getState()?.user?.uid;
    return user_id === space?.owner_id;
  },
  CAN_REMOVE_COLLABORATORS: (space) => {
    if (!space?.owner_id) return true;
    const user_id = UserAuthStore.getState()?.user?.uid;
    return user_id === space?.owner_id;
  },
};
